import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import shouldTableShowCirclePersonas from 'owa-mail-list-actions/lib/utils/tables/shouldTableShowCirclePersonas';
import shouldShowFolderTag from 'owa-mail-list-view/lib/selectors/shouldShowFolderTag';
import { shouldTableSupportFlag } from 'owa-mail-list-actions/lib/utils/tables/shouldTableSupportFlag';
import { shouldTableSortByRenewTime } from 'owa-mail-list-response-processor';
import { isDumpsterTable, listViewStore } from 'owa-mail-list-store';
import { isDumpsterSearchTable } from 'owa-mail-search-store';
import { isGroupTableQuery } from 'owa-group-common';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
export default function getMailListTableProps(tableViewId) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var tableQuery = tableView.tableQuery;
    var isDumpsterOrDumpsterSearchTable = isDumpsterTable(tableQuery) || isDumpsterSearchTable(tableQuery);
    var tableSupportsPinning = shouldTableSortByRenewTime(tableQuery);
    var tableSupportsSnooze = !isGroupTableQuery(tableQuery);
    // Show condensed pinned rows only if table supports pinning and is of type Folder
    // as Search table also supports pinning
    var tableSupportsCondensedPinnedRows = tableView.tableQuery.type === 0 /* Folder */ && tableSupportsPinning;
    // As we do not support moving all items in the folder, we disable dragging
    // in select all mode. We also disable dragging from Group table as that is not supported.
    var canDragFromTable = (!tableView.isInVirtualSelectAllMode &&
        tableView.tableQuery.type == 0 /* Folder */) ||
        tableView.tableQuery.type == 1 /* Search */;
    return {
        tableViewId: tableViewId,
        supportsPinning: tableSupportsPinning,
        supportsFlagging: shouldTableSupportFlag(tableQuery),
        showCirclePersonas: shouldTableShowCirclePersonas(tableQuery),
        showPreviewText: getUserConfiguration().UserOptions.ShowPreviewTextInListView,
        isSingleLine: getUserConfiguration().UserOptions.GlobalReadingPanePositionReact !==
            ReadingPanePosition.Right,
        highlightTerms: tableView.highlightTerms,
        listViewType: tableQuery.listViewType,
        showCondensedPinnedRows: tableSupportsCondensedPinnedRows,
        supportsHoverIcons: !isDumpsterOrDumpsterSearchTable,
        supportsDoubleClick: isMailFeatureEnabled('rp-popouts') && !isDumpsterOrDumpsterSearchTable,
        showFolderTag: shouldShowFolderTag(tableQuery, tableViewId),
        supportsSnooze: tableSupportsSnooze,
        canDragFromTable: canDragFromTable,
    };
}
//# sourceMappingURL=getMailListTableProps.js.map